export class DeviceVerificationRequest {
  unknownDeviceVerificationEnabled: boolean;

  constructor(unknownDeviceVerificationEnabled: boolean) {
    this.unknownDeviceVerificationEnabled = unknownDeviceVerificationEnabled;
  }
}
